import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Row, Col, Button, Clearfix } from 'react-bootstrap';
import {
  remove as _remove,
  forEach as _forEach,
  isArray as _isArray,
  mapKeys as _mapKeys,
  camelCase as _camelCase,
  get as _get,
  includes as _includes,
} from 'lodash';

import { setFilters, resetFilter, removeFilter } from 'actions/SalesActivityDashboardActions';
import { parseQs, stringifyQs } from 'helpers/http';
import { addNotification } from 'actions/NotificationsActions';
import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { deleterDispatchHelper } from 'actions/DeleterActions';

import FiltersetNew from 'components/layout/vkl/FiltersetNew';
import VklFilterDesktop from 'components/layout/vkl/VklFilterDesktop';
import ModalSummaryFilters from 'components/modals/ModalSummaryFilters';

class VklFilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
      showMobileFilters: false,
      deletedFilterset: '',
      filtersets: this.props.filtersets,
      addedFilterset: null,
    };
  }

  showNew = () => {
    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      deleterStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      const filtersetsCopy = this.state.filtersets;
      filtersetsCopy.data.list.push(this.state.addedFilterset);
      this.closeNew();
      this.setState({ filtersets: filtersetsCopy, addedFilterset: null }, () => {
        doNotify(1, messages.changes_saved);
      });
    }

    if (prevProps.deleterStatus.pending && !deleterStatus.pending && !deleterStatus.hasError) {
      const filtersetsCopy = this.state.filtersets;
      _remove(filtersetsCopy.data.list, fs => {
        return fs.id === deleterStatus.data;
      });
      this.setState({ filtersets: filtersetsCopy, deletedFilterset: '' }, () => {
        doNotify(1, messages.changes_saved);
      });
    }
  };

  closeMobileFilters = () => {
    this.setState({ showMobileFilters: false });
  };

  getFilterValues = name => {
    const { filters } = this.props;

    if (filters[name] !== undefined) {
      return filters[name];
    }

    return null;
  };

  // remove a value from array
  removeArrayFilter = (name, value) => {
    let query = parseQs(this.props.location.search);
    let values = query[name].slice();
    values.splice(values.indexOf(value), 1);

    if (!values.length) {
      delete query[name];
    } else {
      query[name] = values;
    }

    this.props.history.push({ pathname: this.props.location.pathname, search: stringifyQs(query) });
  };

  // remove whole array from query
  removeFilter = name => {
    let query = parseQs(this.props.location.search);
    delete query[name];

    this.props.history.push({ pathname: this.props.location.pathname, search: stringifyQs(query) });
  };

  resetFilters = () => {
    this.props.history.push({ pathname: this.props.location.pathname, search: '' });
  };

  getFilterName = name => {
    const {
      intl: { messages },
    } = this.props;

    const mapping = {
      salesmanLastname: messages.sad.salesman,
      salesmanId: messages.sad.salesman,
      salesmanIdBlacklist: messages.sad.salesman_blacklist,
      carModelName: messages.car + '-' + messages.sad.class,
      salesDescriptionShort: messages.car + '-' + messages.model,
      carTypeName: messages.sad.body_design,
      carColor: messages.sad.car_color,
      companyMainNumber: messages.company,
      salesmanCompanyNumber: messages.sad.store,
      year: messages.year,
      month: messages.month,
      status: messages.status,
      source: messages.source,
      isInternalActivity: messages.sad.internal_activity,
    };

    if (mapping.hasOwnProperty(name)) {
      return mapping[name];
    }
    return name;
  };

  getFilterValue = (name, value) => {
    const {
      intl: { messages },
    } = this.props;

    let mapping = {};
    if (name === 'status') {
      mapping = {
        100: messages.sad.offer_made,
        300: messages.sad.in_progress,
        500: messages.sad.predecessor_offer,
        700: messages.sad.lost,
        900: messages.sad.ordered,
        950: messages.sad.canceled,
      };
    } else if (name === 'isInternalActivity') {
      mapping = {
        true: messages.yes,
        false: messages.no,
      };
    }

    if (mapping.hasOwnProperty(value)) {
      return mapping[value];
    }

    return value;
  };

  listTags = () => {
    const { filters } = this.props;

    const result = [];
    _forEach(filters, (values, name) => {
      if (_isArray(values)) {
        _forEach(values, (value, j) => {
          result.push(
            <li onClick={() => this.removeArrayFilter(name, value)} key={name + j}>
              <a href="javascript:;" onClick={() => this.removeArrayFilter(name, value)}>
                {this.getFilterName(name)}: {this.getFilterValue(name, value)}{' '}
                <span class="m-l-10">
                  <i class="fal fa-times" />
                </span>
              </a>
            </li>
          );
        });
      }
    });

    if (result.length) {
      result.splice(
        0,
        0,
        <li key={result.length} class="hidden-print">
          <a href="javascript:;" onClick={this.resetFilters}>
            {this.props.intl.messages.delete_all_filters}{' '}
            <span class="m-l-10">
              <i class="fal fa-times" />
            </span>
          </a>
        </li>
      );

      return (
        <ul class="list-unstyled summary-filter-tags-list inline">
          <Clearfix>{result}</Clearfix>
        </ul>
      );
    }

    return <span class="bold inline v-align-top lh-23 m-t-5">Keine vorhanden</span>;
  };

  onFiltersetSelect = filterset => {
    // Filterattribute von "car_model_name" in "carModelName" umbenennen
    const query = _mapKeys(filterset.filter, function(value, key) {
      return _camelCase(key);
    });
    this.props.history.push({ pathname: this.props.location.pathname, search: stringifyQs(query) });
    this.props.setFilters(query);
  };

  onFiltersetDelete = filterset => {
    this.setState({ deletedFilterset: _get(filterset, 'name') });
    this.props.deleteFilterset(_get(filterset, 'id'));
  };

  addFilterset = (content, filters) => {
    let submitData = {
      name: content,
      filter: {
        ...filters,
      },
    };

    this.setState({ addedFilterset: submitData });
    this.props.onSubmit(submitData);
  };

  render() {
    const {
      intl: { messages },
      filters,
      facets,
      location,
    } = this.props;
    const { filtersets } = this.state;

    return (
      <div>
        <Row>
          <div class="hidden-xs hidden-print">
            {facets.data.list.map((facet, i) => {
              if (!_includes(['category', 'minPrice', 'maxPrice'], facet.id)) {
                return (
                  <Col xs={3} class="m-b-10" key={i}>
                    <VklFilterDesktop facet={facet} filters={filters} location={location} />
                  </Col>
                );
              }

              return null;
            })}
          </div>
        </Row>

        <Row>
          <div class="hidden-sm hidden-md hidden-lg hidden-print">
            <Col xs={12}>
              <Button block bsSize="lg" bsStyle="primary" onClick={() => this.setState({ showMobileFilters: true })}>
                <i class="fas fa-sliders-h" /> {messages.do_filter}
              </Button>
            </Col>
          </div>

          <div class="clearfix">
            <Col xs={12} md={6} class="hidden-print">
              <Row>
                <Col xs={12}>
                  <div>
                    <span class="bold m-r-5">Filtersätze:</span>
                    <Button
                      class="m-r-5 bold"
                      bsStyle="success"
                      bsSize="xsmall"
                      onClick={() => {
                        this.showNew();
                      }}
                    >
                      <i class="fas fa-plus" /> {messages.add}
                    </Button>
                    {filtersets.data.list.map((f, i) => {
                      return (
                        <span style={{ display: 'inline-block' }} class="m-r-5" key={i}>
                          <Button
                            bsStyle="default"
                            bsSize="xsmall"
                            onClick={() => {
                              this.onFiltersetSelect(f);
                            }}
                          >
                            {f.name}
                          </Button>
                          <Button
                            bsStyle="default"
                            style={{ marginLeft: '-5px' }}
                            bsSize="xsmall"
                            onClick={() => {
                              this.onFiltersetDelete(f);
                            }}
                          >
                            <i
                              class={
                                'fa-fw ' +
                                (this.props.deleterStatus.pending && f.name === this.state.deletedFilterset
                                  ? 'fa fa-circle-notch fa-spin '
                                  : 'fal fa-trash-alt text-danger ')
                              }
                            />
                          </Button>
                        </span>
                      );
                    })}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={6}>
              <span class="m-r-5 bold inline v-align-top lh-23 m-t-5">Gesetzte Filter:</span>
              {this.listTags()}
            </Col>
          </div>

          <ModalSummaryFilters
            show={this.state.showMobileFilters}
            close={this.closeMobileFilters}
            resetFilters={this.resetFilters}
            facets={facets}
            filters={filters}
            location={location}
          />
          <div id="filterset-new">
            <FiltersetNew
              filters={filters}
              show={this.state.showNew}
              close={this.closeNew}
              onSaveButtonClicked={this.addFilterset}
              formStatus={this.props.formStatus}
            />
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    filters: state.salesActivityDashboard,
    projectConfig: state.data.projectConfig,
    formStatus: state.formStatus.salesActivityFiltersetAdd,
    deleterStatus: state.deleter.filterset,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setFilters: filters => {
      dispatch(setFilters(filters));
    },
    resetFilters: () => {
      dispatch(resetFilter());
    },
    removeFilter: (name, value) => {
      dispatch(removeFilter(name, value));
    },
    onSubmit: args => {
      formStatusDispatchHelper(
        'salesActivityFiltersetAdd',
        '/api/plugin/salesActivityDashboard/filtersets.json',
        args,
        'post',
        dispatch
      );
    },
    onFormSuccessfull: () => {
      dispatch(formReset('salesActivityFiltersetAdd'));
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    deleteFilterset: filtersetId => {
      deleterDispatchHelper(
        'filterset',
        '/api/plugin/salesActivityDashboard/filtersets/' + filtersetId + '.json',
        dispatch
      );
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(VklFilterBar)
  )
);
